import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useHistory } from "react-router-dom"; // For react-router-dom v5
import Cookies from "universal-cookie";
import { performLogout } from "../../../../../utils/performLogout.js";

const IdleLogoutWrapper = ({ children }) => {
    const history = useHistory();

    const handleOnIdle = () => {
        const cookies = new Cookies();
        const accessToken = cookies.get("access_token");
        const tokenType = cookies.get("token_type");
        
        // Only logout if user has valid tokens
        if (accessToken && tokenType) {
            console.log("User is idle — logging out.");
            performLogout().finally(() => {
                history.push("/auth/login");
            });
        } else {
            console.log("User is idle but no tokens found — already logged out.");
        }
    };

    const handleOnActive = () => {
        // console.log("User is active again — timer reset.");
    };

    useIdleTimer({
        timeout: 1000 * 60 * 25, // 5 minutes
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        debounce: 500,
        events: ["mousemove", "keydown", "mousedown", "touchstart", "scroll"], // all major events
    });

    return <>{children}</>;
};

export default IdleLogoutWrapper;
